import React, { useState } from "react";
import styled from "styled-components";
import Popover from "@material-ui/core/Popover";
import { withStyles } from "@material-ui/core/styles";
import { IconButton } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';

const CustomDarkTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#08091f',
    color: '#FFFFFF',
    borderRadius: '12px',
    boxShadow: theme.shadows[1],
    fontFamily: 'DM Sans',
    fontSize: 12,
  },
  arrow: {
    color: '#08091f'
  }
}))(Tooltip);

const DarkTooltip = ({children, title, placement}) => (
  <CustomDarkTooltip
    arrow
    enterDelay={1300}
    title={title}
    placement={placement}
  >
    {children}
  </CustomDarkTooltip>
)

const StyledPopover = withStyles({
  paper: {
    background: "#060c29",
    borderRadius: "12px",
  },
})(Popover);

const Content = styled.div`
  color: #fff;
  padding: 6px;
  max-height: 360px;
`;

export const CustomPopover = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton color="inherit" onClick={(e) => setAnchorEl(e.currentTarget)}>
        {props.button}
      </IconButton>
      <StyledPopover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl("")}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Content>
          {props.clientTable ? 
            React.Children.map(props.children, (child) =>
              React.cloneElement(child || <></>, { setAnchorEl: (val) => { setAnchorEl(val) } })
            )
          :
            props.children
          }
        </Content>
      </StyledPopover>
    </>
  );
};

const Item = styled.div`
  border-radius: 6px;
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 6px 8px;
  margin: 6px 0px;
  transition: 0.2s ease background;
  &:hover {
    background: #ffffff2e;
  }
  svg {
    /* height: 1.125rem;
    width: 1.125rem; */
  }

  span {
    color: ${props => props.disabled ? '#696c78':'#FFF'};
  }
  p {
    color: ${props => props.disabled ? '#696c78':'#FFF'};
    white-space: nowrap;
    padding-left: 8px;
    font-size: 1rem;
    text-align: left;
    /* padding: 6px 4px; */
    /* margin: 4px 0px; */
    width: 100%;
  }
`;

const TipContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 6px;
  p {
    font-size: .9rem;
    font-weight: normal;
    display: flex;
    align-items: center;
    margin-bottom: 4px;
  }
  li {
    font-size: .9rem;
    font-weight: normal;
    margin-bottom: 4px;
    span {
      font-weight: bold;
    }
  }
  span {
    font-size: .9rem;
    font-weight: normal;
    text-align: center;
    margin-bottom: 4px;
  }
`;

export const PopoverListItem = (props) => {
  return (
    <Item 
      onClick={() => {
        props.onClick();
        if (props.hideOnClick) {
          props.setAnchorEl('')
        }
      }}
      disabled={props.disabled}
    >
      {props.icon}
      <p>{props.text}</p>
    </Item>
  );
};

